module.exports = __webpack_public_path__ + "img/shibai.dbf77009.png";